const styles = theme => ({
  infoCircle: {
    width: "0.8em",
    height: "0.8em",
    color: theme.palette.text.hint,
    cursor: "pointer",
  },
  infoTooltip: {
    fontSize: "0.8em",
    maxWidth: "240px",
    textAlign: "center",
  },
})

export default styles
